<p-dialog
  #mainDialog
  [visible]="dialogVisibleState()"
  [modal]="true"
  [closable]="false"
  [closeOnEscape]="false"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="false"
  [style]="dialogStyle()"
  [styleClass]="dialogStyleClass"
  [contentStyle]="{ padding: '0', overflow: 'hidden' }"
  [baseZIndex]="1100"
  (onShow)="onMainDialogShown()"
  (onHide)="onDialogHidden()"
>
  <ng-template pTemplate="header" let-ariaLabelledBy="ariaLabelledBy">
    <div class="form-modal-shell__header">
      <h2 class="form-modal-shell__heading p-dialog-title" [id]="ariaLabelledBy">{{ heading() }}</h2>

      <button
        pButton
        type="button"
        severity="secondary"
        [text]="true"
        [rounded]="true"
        [disabled]="interactionLocked()"
        [tabindex]="interactionLocked() ? -1 : 0"
        aria-label="Zamknij"
        class="form-modal-shell__header-close"
        (click)="onHeaderCloseButtonClick()"
        (pointerdown)="$event.preventDefault()"
      >
        <span pButtonIcon class="pi pi-times" aria-hidden="true"></span>
      </button>
    </div>
  </ng-template>

  <section
    #shellContainer
    class="form-modal-shell"
    [class.form-modal-shell--resize-animated]="animateContentResize()"
  >
    @if (subtitle(); as subtitleText) {
      <div class="form-modal-shell__subtitle-row">
        <p class="form-modal-shell__subtitle">{{ subtitleText }}</p>
      </div>
    }

    <div class="form-modal-shell__body">
      <ng-content />
    </div>

    <footer class="form-modal-shell__footer">
      <div class="form-modal-shell__actions">
        <button
          pButton
          type="button"
          severity="secondary"
          [outlined]="true"
          [disabled]="interactionLocked()"
          (click)="onCancelButtonClick()"
          (pointerdown)="$event.preventDefault()"
        >
          <span class="form-modal-shell__action-label">{{ cancelLabel() }}</span>
        </button>

        @if (submitFormId(); as formId) {
          <button
            pButton
            type="submit"
            [attr.form]="formId"
            [disabled]="interactionLocked() || submitDisabled()"
            [attr.aria-busy]="savingBusy()"
          >
            <span class="form-modal-shell__action-content">
              <span class="form-modal-shell__action-icon" aria-hidden="true">
                @if (savingBusy()) {
                  <i class="pi pi-spin pi-spinner"></i>
                } @else {
                  <i class="pi pi-check"></i>
                }
              </span>
              <span class="form-modal-shell__action-label">{{ saveLabel() }}</span>
            </span>
          </button>
        } @else {
          <button
            pButton
            type="button"
            [disabled]="interactionLocked() || submitDisabled()"
            [attr.aria-busy]="savingBusy()"
            (click)="onSaveRequested()"
          >
            <span class="form-modal-shell__action-content">
              <span class="form-modal-shell__action-icon" aria-hidden="true">
                @if (savingBusy()) {
                  <i class="pi pi-spin pi-spinner"></i>
                } @else {
                  <i class="pi pi-check"></i>
                }
              </span>
              <span class="form-modal-shell__action-label">{{ saveLabel() }}</span>
            </span>
          </button>
        }
      </div>
    </footer>
  </section>
</p-dialog>
